import { DateTime } from 'luxon'
import * as React from 'react'
import { getEventIcon, getEventName } from '../../helpers/eventHelper.tsx'
import { IEvent } from '../../interfaces/types.ts'
import controlStore from '../../store/controlStore.ts'
import authStore from '../../store/authStore.ts'

interface Props {
    event: IEvent,
    index: number
}

export const EventItem: React.FC<Props> = (props) => {
    const { event, index  } = props
    const isMobile = controlStore(s => s.isOnMobileDevice)
    const effectiveTimezone = authStore(s => s.effectiveTimezone)

    const dateTime = DateTime.fromISO(event.createdAt).setZone(effectiveTimezone().value).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
    const name = getEventName(event)
    // const severity = getEventSeverity(event)
    const icon = getEventIcon(event)

    const textStyle = isMobile ? 'text-sm' : 'text-lg'
    return (
        <div
            key={event._id}
            className={`flex items-center w-full px-2 py-1 gap-2 ${index % 2 ? 'bg-info/60' : 'bg-info/30'}`}
        >
            <div className={'shrink-0'}>{icon}</div>
            {isMobile ? (
                <div className={'flex flex-col min-w-0 flex-1'}>
                    <div className={'text-base font-bold leading-tight'}>{name}</div>
                    <div className={'text-sm text-gray-500 mt-0.5'}>{dateTime}</div>
                </div>
            ) : (
                <div className={`flex justify-between items-center w-full`}>
                    <div className={`${textStyle} font-bold`}>{name}</div>
                    <div className={`${textStyle} pr-2`}>{dateTime}</div>
                </div>
            )}
        </div>
    )
}
